import { Message } from './index.d';

export default function format({ timestamp, name, level, text }: Message) {
  const ts = new Date(timestamp).toISOString();
  return `[${ts}] ${level} - ${name}: ${text}`;
}
